import { KalgudiError } from './kalgudi-error';

/**
 * Rest api error handler
 */
export class ApiError extends KalgudiError { }

export class LazySyncApiError extends ApiError {}
